import { cinemaChain } from "../constants";

const decodeSeoValue = (value = "") => {
  if (value === null || value === undefined) {
    return "";
  }

  try {
    return decodeURIComponent(String(value));
  } catch (error) {
    return String(value);
  }
};

export const normalizeSeoText = (value = "") =>
  decodeSeoValue(value).replace(/\s+/g, " ").trim();

export const formatSeoRouteLabel = (value = "") => {
  const decoded = decodeSeoValue(value);
  const lower = decoded.toLowerCase();
  if (lower.includes("ncr") || lower.includes("all")) {
    return normalizeSeoText(decoded);
  }
  return normalizeSeoText(decoded.replace(/-/g, " "));
};

export const formatSeoCityName = (value = "") => formatSeoRouteLabel(value);

export const formatUrlSlug = (value = "", { preserveCase = true } = {}) => {
  const normalizedValue = normalizeSeoText(value);
  if (!normalizedValue) {
    return "";
  }

  const sanitizedValue = normalizedValue
    .replace(/&/g, " and ")
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");

  return preserveCase ? sanitizedValue : sanitizedValue.toLowerCase();
};

export const getCanonicalBaseUrl = () =>
  cinemaChain === "PVR"
    ? "https://www.pvrcinemas.com"
    : "https://www.inoxmovies.com";

export const normalizeCanonicalPath = (pathname = "/") => {
  let normalizedPath = String(pathname || "/").trim();

  if (!normalizedPath.startsWith("/")) {
    normalizedPath = `/${normalizedPath}`;
  }

  normalizedPath = normalizedPath
    .replace(/\/index(?:\.html)?$/i, "/")
    .replace(/^\/home$/i, "/");

  if (normalizedPath !== "/") {
    normalizedPath = normalizedPath.replace(/\/+$/, "");
  }

  return normalizedPath || "/";
};

export const formatCanonicalSegment = (value = "") => {
  const normalizedValue = normalizeSeoText(value);
  if (!normalizedValue) {
    return "";
  }

  return normalizedValue
    .split(/[\s-]+/)
    .filter(Boolean)
    .map((segment) => {
      if (segment === segment.toUpperCase() && segment.length <= 4) {
        return segment;
      }

      return segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase();
    })
    .join("-");
};

export const buildCanonicalUrl = (pathOrSegments = "/") => {
  const pathname = Array.isArray(pathOrSegments)
    ? `/${pathOrSegments.filter(Boolean).join("/")}`
    : pathOrSegments;

  return `${getCanonicalBaseUrl()}${normalizeCanonicalPath(pathname)}`;
};

export const buildMovieSessionPath = (
  city = "",
  movieName = "",
  movieId = "",
  experienceValue = ""
) => {
  const pathSegments = [
    "moviesessions",
    formatUrlSlug(city),
    formatUrlSlug(movieName),
    movieId,
    formatUrlSlug(experienceValue),
  ].filter(Boolean);

  return `/${pathSegments.join("/")}`;
};

export const buildMovieSessionUrl = (
  city = "",
  movieName = "",
  movieId = "",
  experienceValue = ""
) => buildCanonicalUrl(buildMovieSessionPath(city, movieName, movieId, experienceValue));

export const getAlternateLanguageLinks = (url = "") =>
  url
    ? [
        { hrefLang: "en-IN", href: url },
        { hrefLang: "x-default", href: url },
      ]
    : [];

export const getCurrentCanonicalUrl = () =>
  typeof window === "undefined"
    ? buildCanonicalUrl("/")
    : buildCanonicalUrl(window.location.pathname);
